import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome-alwayson',
  templateUrl: './welcome-alwayson.component.html',
  styleUrls: ['./welcome-alwayson.component.scss']
})
export class WelcomeAlwaysonComponent implements OnInit {

  welcomeName: any;
  welcomeLastName: any;
  welcomeMessage: any;

  constructor() { }

  ngOnInit(){

  }

  sendWelcomeForm(){
    let _ = this;
    let welcomeData = {
      name: _.welcomeName,
      lastname: _.welcomeLastName,
      message: _.welcomeMessage
    }
    console.log(welcomeData);
  }

}
